export function isPointerInBounds(view, param) {
    var x = param.x, y = param.y;
    var rect = view.getBoundingClientRect();
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
}
